import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import classNames from 'classnames';

import Services from './Services';
import UserDetails from './UserDetails';
import GiftCard from 'container/components/GiftCard/GiftCard';

function SmallScreenModels(props) {
  const { setMobileMenu, setSignUpModal, mobileMenu, setSubscriptionModal } =
    props;

  const dispatch = useDispatch();

  const open = useSelector(state => state.utils.openMobileRightMenu);

  const handleClose = () => {
    dispatch.utils.setOpenMobileRightMenu(false);
  };

  return (
    <Container
      className={classNames('small__screen-models', 'modal')}
      style={{ display: open ? 'flex' : 'none' }}
    >
      <div className='wrapper'>
        <div className='right-top'>
          <div
            className='close-box d-flex justify-content-end pr-5'
            onClick={handleClose}
            role='button'
          >
            <svg
              width='25'
              height='25'
              viewBox='0 0 10 10'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.18036 3.32412L6.80021 0.70634L6.09282 -0.000488281L3.47297 2.6173L0.853625 7.21216e-06L0.14624 0.706836L2.76559 3.32412L0.14624 5.94141L0.853625 6.64824L3.47297 4.03095L6.09282 6.64874L6.80021 5.94191L4.18036 3.32412Z'
                fill='white'
              />
            </svg>
          </div>
          {/* Services */}
          <Services setMobileMenu={setMobileMenu} mobileMenu={mobileMenu} />
          {/* Marketplace */}
          {/* <Marketplace /> */}
        </div>
        <div style={{ marginTop: 'auto' }}>
          <GiftCard />
        </div>
        {/* User details / buttons for signed in or signed up user */}
        <UserDetails
          setMobileMenu={setMobileMenu}
          setSignUpModal={setSignUpModal}
          setSubscriptionModal={setSubscriptionModal}
        />
      </div>
    </Container>
  );
}

export default SmallScreenModels;

const Container = styled.div`
  z-index: 50;
  &.modal {
    display: flex !important;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    position: fixed;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;

    & .wrapper {
      width: 100%;
      flex-direction: column;
      justify-content: space-between;
      padding-left: 10px;
    }
  }

  & .close-box {
    margin-top: 10px;
  }
`;
